import {
  COUPON_LIST,
  COUPON_GET,
  COUPON_CREATE,
  COUPON_UPDATE,
  COUPON_PAUSE,
  COUPON_RESUME,
  COUPON_ARCHIVE,
  COUPON_SERIES_GET,
  COUPON_SERIES_CANCEL,
  COUPON_CODE_LOOKUP,
  COUPON_APPLY,
  COUPON_REVERSE,
  COUPON_USAGE_SYNC,
} from "../types";

export const couponListAction = (data, onSuccess, onError) => ({
  type: COUPON_LIST,
  data,
  onSuccess,
  onError,
});

export const couponGetAction = (data, onSuccess, onError) => ({
  type: COUPON_GET,
  data,
  onSuccess,
  onError,
});

export const couponCreateAction = (data, onSuccess, onError) => ({
  type: COUPON_CREATE,
  data,
  onSuccess,
  onError,
});

export const couponUpdateAction = (data, onSuccess, onError) => ({
  type: COUPON_UPDATE,
  data,
  onSuccess,
  onError,
});

export const couponPauseAction = (data, onSuccess, onError) => ({
  type: COUPON_PAUSE,
  data,
  onSuccess,
  onError,
});

export const couponResumeAction = (data, onSuccess, onError) => ({
  type: COUPON_RESUME,
  data,
  onSuccess,
  onError,
});

export const couponArchiveAction = (data, onSuccess, onError) => ({
  type: COUPON_ARCHIVE,
  data,
  onSuccess,
  onError,
});

export const couponSeriesGetAction = (data, onSuccess, onError) => ({
  type: COUPON_SERIES_GET,
  data,
  onSuccess,
  onError,
});

export const couponSeriesCancelAction = (data, onSuccess, onError) => ({
  type: COUPON_SERIES_CANCEL,
  data,
  onSuccess,
  onError,
});

export const couponCodeLookupAction = (data, onSuccess, onError) => ({
  type: COUPON_CODE_LOOKUP,
  data,
  onSuccess,
  onError,
});

export const couponApplyAction = (data, onSuccess, onError) => ({
  type: COUPON_APPLY,
  data,
  onSuccess,
  onError,
});

export const couponReverseAction = (data, onSuccess, onError) => ({
  type: COUPON_REVERSE,
  data,
  onSuccess,
  onError,
});

export const couponUsageSyncAction = (data, onSuccess, onError) => ({
  type: COUPON_USAGE_SYNC,
  data,
  onSuccess,
  onError,
});
